import React from 'react';
import { User, LogOut, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import keycloak from '../../services/auth/keycloak';
import logoSvg from '../../assets/qavok-logo-color-light-bg.svg';

const Header: React.FC = () => {
  const { user } = useAuthStore();
  const { i18n, t } = useTranslation();

  const handleLogout = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };

  const toggleLang = () => {
    const next = i18n.language === 'fr' ? 'en' : 'fr';
    i18n.changeLanguage(next);
    localStorage.setItem('qavok-lang', next);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-3" role="banner">
      <div className="flex items-center justify-between">
        <img src={logoSvg} alt="QAVOK" className="h-12" />

        <div className="flex items-center space-x-4">
          <button
            onClick={toggleLang}
            className="flex items-center gap-1 text-xs text-gray-500 hover:text-blue-600 transition-colors px-2 py-1 rounded border border-gray-200 hover:border-blue-300"
            aria-label="Change language"
          >
            <Globe className="h-3.5 w-3.5" />
            <span className="font-medium uppercase">{i18n.language}</span>
          </button>
          <div className="flex items-center space-x-2">
            <User className="h-5 w-5 text-gray-600" aria-hidden="true" />
            <span className="text-sm text-gray-700">{user?.name || 'User'}</span>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center text-sm text-gray-500 hover:text-red-600 transition-colors"
            aria-label={t('auth.logout')}
            title={t('auth.logout')}
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
